import { render } from "./WithholdingAgentSelectGroup.vue?vue&type=template&id=ba7d1430"
import script from "./WithholdingAgentSelectGroup.vue?vue&type=script&lang=js"
export * from "./WithholdingAgentSelectGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__